import axios from "axios";
import { useState, useEffect } from "react";
import { Button } from "../../components";
import "./styles.css";

function LeaderBoard() {
	const [scores, setScores] = useState([]);
	const [count, setCount] = useState(5);
	const [filters, setFilters] = useState({
		category: "Any Category",
		difficulty: "Any Difficulty",
		type: "Any Type"
	});

	useEffect(() => {
		async function fetchData() {
			let body = {
				params: {
					noOfQuestions: count,
					category: filters.category,
					difficulty: filters.difficulty,
					type: filters.type
				}
			};
			const scores = await axios.get(
				`${process.env.REACT_APP_USERS_API_URL}/scores/filter`,
				body
			);
			scores.data.forEach((score, index) => (score.rank = index + 1));
			setScores(scores.data);
		}
		fetchData();
	}, [count, filters]);

	const handleIncrement = (e) => {
		e.preventDefault();
		if (count < 10) {
			setCount((prevState) => prevState + 1);
		}
	};

	const handleDecrement = (e) => {
		e.preventDefault();
		if (count > 1) {
			setCount((prevState) => prevState - 1);
		}
	};

	const handleChange = (e) => {
		setFilters((prevState) => ({
			...prevState,
			[e.target.name]: e.target.value
		}));
	};

	return (
		<div className="leaderboardContainer">
			<div className="leaderboardWrapper">
				<h1>Leaderboard</h1>
				<h2>Choose a Leaderboard to View</h2>
				<div className="filterContainer">
					<div className="noOfQuestionsContainer">
						<p>{count}</p>
						<Button
							onClick={(e) => {
								handleDecrement(e);
							}}
							text={
								<>
									Subtract<span></span>
									<span class="cybrBtnGlitch">Subtract</span>
								</>
							}
						/>
						<Button
							onClick={(e) => {
								handleIncrement(e);
							}}
							text={
								<>
									Add<span></span>
									<span class="cybrBtnGlitch">Add</span>
								</>
							}
						/>
					</div>
					<div>
						<form id="quizform">
							<select
								name="category"
								value={filters.category}
								onChange={handleChange}
							>
								<option value="Any Category">Any Category</option>
								<option value="General Knowledge">General Knowledge</option>
								<option value="Entertainment: Books">
									Entertainment: Books
								</option>
								<option value="Entertainment: Film">Entertainment: Film</option>
								<option value="Entertainment: Music">
									Entertainment: Music
								</option>
								<option value="Entertainment: Musicals & Theatres">
									Entertainment: Musicals & Theatres
								</option>
								<option value="Entertainment: Television">
									Entertainment: Television
								</option>
								<option value="Entertainment: Video Games">
									Entertainment: Video Games
								</option>
								<option value="Entertainment: Board Games">
									Entertainment: Board Games
								</option>
								<option value="Science & Nature">Science & Nature</option>
								<option value="Science: Computers">Science: Computers</option>
								<option value="Science: Mathematics">
									Science: Mathematics
								</option>
								<option value="Mythology">Mythology</option>
								<option value="Sports">Sports</option>
								<option value="Geography">Geography</option>
								<option value="History">History</option>
								<option value="Politics">Politics</option>
								<option value="Art">Art</option>
								<option value="Celebrities">Celebrities</option>
								<option value="Animals">Animals</option>
								<option value="Vehicles">Vehicles</option>
								<option value="Entertainment: Comics">
									Entertainment: Comics
								</option>
								<option value="Science: Gadgets">Science: Gadgets</option>
								<option value="Entertainment: Japanese Anime & Manga">
									Entertainment: Japanese Anime & Manga
								</option>
								<option value="Cartoon & Animations">
									Cartoon & Animations
								</option>
							</select>
							<select
								name="difficulty"
								value={filters.difficulty}
								onChange={handleChange}
							>
								<option value="Any Difficulty">Any Difficulty</option>
								<option value="Easy">Easy</option>
								<option value="Medium">Medium</option>
								<option value="Hard">Hard</option>
							</select>
							<select name="type" value={filters.type} onChange={handleChange}>
								<option value="Any Type">Any Type</option>
								<option value=">Multiple Choice">Multiple Choice</option>
								<option value="True / False">True / False</option>
							</select>
						</form>
					</div>
				</div>
				<div className="tableContainer">
					<table>
						<tr>
							<th>Rank</th>
							<th>Name</th>
							<th>Number of Questions</th>
							<th>Category</th>
							<th>Difficulty</th>
							<th>Question Type</th>
							<th>Score</th>
						</tr>
						{scores.map((score) => {
							return (
								<tr className="tr">
									<td>{score.rank}</td>
									<td>{score.name}</td>
									<td>{score.noOfQuestions}</td>
									<td>{score.category}</td>
									<td>{score.difficulty}</td>
									<td>{score.type}</td>
									<td>
										{score.score}/{score.noOfQuestions}
									</td>
								</tr>
							);
						})}
					</table>
				</div>
			</div>
		</div>
	);
}

export default LeaderBoard;
